module.exports = __webpack_public_path__ + "img/lofi.f7ffefde.jpg";